import Box from "@mui/material/Box"
import Chip from "@mui/material/Chip"
import CircularProgress from "@mui/material/CircularProgress"
import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { Navigate, Outlet } from "react-router-dom"

import { adminLayoutBackgroundSx, adminPageSx } from "./adminStyles"
import AdminLiquidPage from "./components/AdminLiquidPage"
import AdminSectionTabs from "./components/AdminSectionTabs"
import AdminSidebar, { DRAWER_WIDTH } from "./components/AdminSidebar"
import { isAdminDemoMode } from "./mockData"
import {
  adminRestoreSession,
  selectAdminIsRestoringSession,
  selectAdminToken,
} from "./reducer"

export default function AdminLayout() {
  const dispatch = useDispatch()
  const token = useSelector(selectAdminToken)
  const isRestoringSession = useSelector(selectAdminIsRestoringSession)

  useEffect(() => {
    if (localStorage.getItem("smartsetter.admin.token")) {
      dispatch(adminRestoreSession())
    }
  }, [dispatch])

  if (isRestoringSession) {
    return (
      <Box
        sx={{
          ...adminLayoutBackgroundSx,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          ...adminPageSx,
        }}
      >
        <CircularProgress />
      </Box>
    )
  }

  if (!token) {
    return <Navigate to="/admin/log-in/" replace />
  }

  return (
    <Box
      sx={{
        ...adminLayoutBackgroundSx,
        position: "relative",
        display: "flex",
        ...adminPageSx,
      }}
    >
      <AdminSidebar />
      <Box
        component="main"
        sx={{
          flex: 1,
          minWidth: 0,
          minHeight: "100vh",
          overflowY: "auto",
          p: { xs: 2, sm: 3 },
          pt: 2,
          width: `calc(100% - ${DRAWER_WIDTH}px)`,
          ...adminPageSx,
        }}
      >
        {isAdminDemoMode() && (
          <Chip
            label="Demo mode — sample data"
            color="secondary"
            size="small"
            sx={{ mb: 2 }}
          />
        )}
        <AdminLiquidPage>
          <AdminSectionTabs />
          <Outlet />
        </AdminLiquidPage>
      </Box>
    </Box>
  )
}
